// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Cq-z","breadcrumbForward":"Dq-z","breadcrumbBack":"Eq-z","selected":"Fq-z"};